<div class="container">
  <div class="header">
    <h2 class="page-title">Лицензия</h2>
    <div class="invoice" (click)="onOpenOverlay()" role="button">
      <div class="text">Загрузить документы, подтверждающие оплату</div>
      <div class="arrow"></div>
    </div>
  </div>
</div>
